import { Pipe, PipeTransform } from '@angular/core';
import { AttributesGroup } from '@app/shared/interfaces/Attribute';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { CustomAttributeGroup } from '../models/AttributeDTO';

@Pipe({
  name: 'AttributesGroupFields',
})
export class AttributesGroupFieldsPipe implements PipeTransform {
  transform(group: any): any {
    let fields: ModelField[] = [];
    if (Object.keys(group).indexOf('Attributes') > -1) {
      fields = group.Attributes.map((x: any) => {
        const field: ModelField = {
          Code: x.Id,
          DataType: +x.Type!,
          Required: x.IsRequired,
          Title: x.Label,
          Scope: x.Scope ?? '1',
          Object: x.Object ?? x.RelationObjectType,
          AdditionalData: x.AdditionalData ?? undefined,
          Visible: x.visible,
        };
        return field;
      });
    } else {
      fields = group.attributes.map((x: any) => {
        const field: ModelField = {
          Code: x.id,
          DataType: +x.type!,
          Required: x.isRequired,
          Title: x.label,
          Scope: x.scope ?? '1',
          Object: x.object ?? x.relationObjectType,
          AdditionalData: x.additionalData ?? undefined,
          Visible: x.visible,
        };
        return field;
      });
    }
    fields = fields.filter((x) => x.DataType !== 8);
    return fields;
  }
}

export function ConvertAttributeToField(attribute: any) {
  const field: ModelField = {
    Code: attribute.Id ?? attribute.id,
    DataType: +(attribute.Type ?? attribute.type),
    Required: attribute.IsRequired ?? attribute.isRequired,
    Title: attribute.Label ?? attribute.label,
    Scope: attribute.Scope ?? attribute.scope ?? '1',
    Visible: attribute.visible,
    Object:
      attribute.Object ??
      attribute.object ??
      attribute.RelationObjectType ??
      attribute.relationObjectType,
  };
  return field;
}
